<mdb-card narrower="true" cascade="true">
    <div class="row">
        <div class="col-md-12">
            <app-card-header [headingSize]="5" [fullHeader]="true" title="{{cvm.title}}">
            </app-card-header>
        </div>
    </div>

    <mdb-card-body cascade="true">
        <div *ngIf="!cvm.chartDatasets || !cvm.chartDatasets.length" style="display: block;">
            <span>No data found at the moment!</span>
        </div>
        <div *ngIf="cvm.chartDatasets && cvm.chartDatasets.length > 0" style="display: block;">
            <canvas mdbChart [chartType]="cvm.chartType" [datasets]="cvm.chartDatasets"
                [labels]="cvm.chartLabels" [colors]="cvm.chartColors" [options]="cvm.chartOptions"
                [legend]="cvm.legend" (chartHover)="hover(vm, cvm, $event)"
                (chartClick)="clicked(vm, cvm, $event)">
            </canvas>
        </div>
        <div class="row" *ngIf="cvm.chartDatasets && cvm.chartDatasets.length > 0 && cvm.isDetailsAvailable">
            <div class="col-md-8"></div>
            <div class="col-md-4">
                <a class="text-info d-flex justify-content-end" (click)="details(cvm.clientRoute)"><small>View Details...</small></a>
            </div>
        </div>
    </mdb-card-body>
</mdb-card>
